import TextareaAutosize from './TextareaAutosize.vue';

/** Local Vue 3 port of vue-textarea-autosize (7 <textarea-autosize> usages). */
export default {
	install(app) {
		app.component('textarea-autosize', TextareaAutosize);
	},
};
